<template>
  <layout-main-inner>
    <div slot="action">
      <el-dropdown>
        <el-button type="primary">
          新增<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in contentMode"
            :key="item.value"
            @click.native="additem(item.value)">{{ item.label }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <layout-card-wrap hasSlot>
      <div slot="form">
        <goods-status-select v-model="config.status" />
        <el-input
          v-model="config.title"
          style="margin-left: 10px;width: 250px"
          clearable
          placeholder="请输入标题名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          label="资讯标题"
          fixed="left"
          min-width="280"
          prop="title"> </el-table-column>
        <el-table-column
          label="资讯分组"
          min-width="120"
          prop="topicName"> </el-table-column>
        <el-table-column
          label="资讯模式"
          min-width="120">
          <template slot-scope="{ row }">{{ row.contentType | ContentModeName() }}</template>
        </el-table-column>
        <el-table-column
          label="资讯来源"
          min-width="100"
          prop="source"> </el-table-column>
        <el-table-column
          label="浏览次数"
          width="80"
          prop="viewCount"> </el-table-column>
        <el-table-column
          label="排序值"
          width="60"
          prop="sort"> </el-table-column>
        <el-table-column
          label="状态"
          width="80"
          prop="status"
          :formatter="row => row.status === 1 ? '已上架' : '已下架'"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="100">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :disabled="row.status === 1"
                  @click.native="onsale(row, 1)">上架政策资讯</el-dropdown-item>
                <el-dropdown-item
                  :disabled="row.status === 0"
                  @click.native="onsale(row, 0)">下架政策资讯</el-dropdown-item>
                <el-dropdown-item @click.native="showDetail(row)">查看政策详情</el-dropdown-item>
                <el-dropdown-item @click.native="deleteitem(row)">删除政策资讯</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>

    <edit-info-modal
      ref="edit"
      @fetch="fetchList" />

    <detail-drawer ref="detail" />
  </layout-main-inner>
</template>
<script>
import GoodsStatusSelect from '@/pages/goods/busi/goods-status-select.vue'
import EditInfoModal from './edit-info-modal.vue'
import Common from '@/service/common'
import DetailDrawer from './detail-drawer.vue'
export default {
  name: 'SwiperTable',
  components: { EditInfoModal, GoodsStatusSelect, DetailDrawer },
  props: {
    title: { type: String, default: '' },
    contentMode: { type: Array, default() { return [] } }
  },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, title: '', status: null }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    updateitem(row) {
      const { id, title, image, contentType, content, status, sort, topic, source, createdTime } = row
      const contentNew = {}
      if (contentType === 0) {
        contentNew.content1 = this.$splitImage(content)
      } else if (contentType === 1) {
        contentNew.content = content
      }
      this.$refs.edit.init({ id, title, image: this.$splitImage(image), contentType, ...contentNew, status, sort, topic, source, createdTime })
    },
    additem(contentType) {
      this.$refs.edit.init({ contentType })
    },
    showDetail(row) {
      this.$refs.detail.fetch({ id: row.id })
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm(`您确定删除该${this.title}?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Common.deleteinfo({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
    },
    onsale(row, status) {
      const title = status === 1 ? '上架' : '下架'
      this.$confirm(`您确定${title}该${this.title}?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Common.updateinfo({ id: row.id, status, vendorId: row.vendorId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success(title + '成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Common.getinfos({ ...this.config })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
